const resolveMediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  if (url.startsWith('http')) {
    try {
      const parsed = new URL(url);
      if (parsed.pathname.startsWith('/api/uploads')) {
        return `${process.env.REACT_APP_BACKEND_URL}${parsed.pathname}`;
      }
    } catch (e) {}
    return url;
  }
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export default resolveMediaUrl;
